<ma-history-modal
  [task]="state.task"
  [taskInfos]="state.taskInfos"
  [assetPictureId]="state.toolingPictureId"
  [details]="state.details"
  [asset]="taskModalService.tooling$ | async"
>
</ma-history-modal>
